import { render, staticRenderFns } from "./WorkqueuesList.vue?vue&type=template&id=baa8516a"
import script from "./WorkqueuesList.vue?vue&type=script&lang=js"
export * from "./WorkqueuesList.vue?vue&type=script&lang=js"
import style0 from "./WorkqueuesList.vue?vue&type=style&index=0&id=baa8516a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports